@if (show()) {
  <div class="virtual-keyboard" [ngStyle]="{ top: topOffset() + 'px', left: leftOffset() + 'px' }" #keyboardRef>
    <div class="drag-handle" #dragHandle>
      <cue-icon [icon]="ICONS.cueMove" /> {{ translation.navigation.drag | transloco }}
    </div>
    @if (keyboardLayout) {
      <div class="keyboard-row">
        @for (key of keyboardLayout.firstRow; track key) {
          <ng-container [ngTemplateOutletContext]="{ buttonCrate: key }" [ngTemplateOutlet]="keyboardRow" />
        }
      </div>
      <div class="keyboard-row">
        <button class="key hidden"></button>
        @for (key of keyboardLayout.secondRow; track key) {
          <ng-container [ngTemplateOutletContext]="{ buttonCrate: key }" [ngTemplateOutlet]="keyboardRow" />
        }
      </div>

      <div class="keyboard-row">
        @for (key of keyboardLayout.thirdRow; track key) {
          <ng-container [ngTemplateOutletContext]="{ buttonCrate: key }" [ngTemplateOutlet]="keyboardRow" />
        }
      </div>

      <div class="keyboard-row">
        @for (key of keyboardLayout.fourthRow; track key) {
          <ng-container [ngTemplateOutletContext]="{ buttonCrate: key }" [ngTemplateOutlet]="keyboardRow" />
        }
      </div>
      <div class="keyboard-row">
        @for (key of keyboardLayout.fifthRow; track key) {
          <ng-container [ngTemplateOutletContext]="{ buttonCrate: key }" [ngTemplateOutlet]="keyboardRow" />
        }
      </div>
    }

    <ng-template #keyboardRow let-buttonCrate="buttonCrate">
      <button
        (mousedown)="handleKeyPress(buttonCrate, $event)"
        class="key"
        [class]="buttonCrate.class"
        [ngClass]="{
          active: (isShiftActive && buttonCrate.isShiftFn) || (isCtrlActive && buttonCrate.isCtrlFn),
          'shift-active': isShiftActive && buttonCrate.class === 'special-chars',
        }"
        [disabled]="isCtrlActive && buttonCrate.isShiftFn"
      >
        @if (isSpecialKeys(buttonCrate) || buttonCrate.isSpaceFn) {
          @if (buttonCrate.isDeleteFn) {
            <cue-icon [icon]="ICONS.cueDeleteBackspace" />
          }
          @if (buttonCrate.isShiftFn) {
            Shift
          }
          @if (buttonCrate.isCapsLockFn) {
            Caps Lock
          }
          @if (buttonCrate.isSpaceFn) {
            <cue-icon [icon]="ICONS.cueSpacebar" />
          }
          @if (buttonCrate.isCtrlFn) {
            <cue-icon [icon]="ICONS.cueSpecialChars" />
          }
          @if (buttonCrate.isEnterFn) {
            <cue-icon [icon]="ICONS.cueEnter" />
          }
          @if (buttonCrate.isCloseFn) {
            <cue-icon [icon]="ICONS.cueClose" />
          }
        } @else {
          @if (isShiftActive || isCapsLockActive) {
            {{ buttonCrate.shiftValue || buttonCrate.defaultValue.toUpperCase() }}
          }
          @if (isCtrlActive && !isShiftActive) {
            {{ buttonCrate.ctrlValue }}
          }
          @if (!isShiftActive && !isCtrlActive && !isCapsLockActive) {
            {{ buttonCrate.defaultValue }}
          }
        }
      </button>
    </ng-template>
  </div>
}
